import { v4 as uuidv4 } from 'uuid'

// test: jest src/models/__tests__/DynamicFormField.model.spec.js
export default class DynamicFormField {
  /**
   * NOTE: 舊版的 form_subjects 中包含 config 結構(一個 db column)；而新版的欄位設定會儲存在 table.config.fields 的 JSON 結構內，因此 field 內沒有 config 結構。
   * 此 class 會將 config 扁平化並消除之，讓所有與 DynamicForm 相關的程式皆能相容兩者且不需處理 config 結構的複雜性。
   */
  constructor(rawData) {
    this._rawData = rawData
  }

  static fromArray(arrayItems) {
    return arrayItems.map(item => new DynamicFormField(item))
  }

  static assignableCustomerDataFields() {
    return [
      {
        displayName: '會員名稱',
        key: 'name'
      },
      {
        displayName: '手機',
        key: 'mobile_phone'
      },
      {
        displayName: 'Email',
        key: 'email'
      },
      {
        displayName: '姓名',
        key: 'extra.name'
      },
      {
        displayName: '自訂',
        key: 'custom'
      },
    ]
  }

  isCollectionField() {
    return ['collection_select', 'collection_carousel'].includes(this.type)
  }

  get availableOptionsForCustomer() {
    return this.options.filter(option => [undefined, null, false].includes(option.staff_only))
  }

  prepareFieldValueForTwoWayBinding(fieldValue) {
    if (this.type === "checkbox") {
      return Array.isArray(fieldValue)
        ? fieldValue
        : [fieldValue].filter(Boolean);
    } else {
      return fieldValue;
    }
  }

  // 輸出 JSON 結構以利儲存，這裡會把 config 結構拆掉，只輸出扁平的結構
  flattenedAttributes() {
    const { config, ...rest } = this._rawData
    return {
      ...config,
      ...rest,
      _id: this._id,
    }
  }

  // Read-only properties，這裡的 getters 需要兼容 config 結構
  get _id() { // generated by uuid, does not and should not be considered as primary key in database
    return this._rawData._id || this._rawData.config?._id || (this._uuid || (this._uuid = uuidv4()))
  }
  get type() {
    return this._rawData.type
  }
  get order() {
    return this._rawData.order
  }
  get title() {
    return this._rawData.title || this._rawData.config?.title
  }
  get collection_id() {
    return this._rawData.collection_id || this._rawData.config?.collection_id
  }
  get dashboard_only() {
    return this._rawData?.dashboard_only ?? this._rawData?.config?.dashboard_only ?? false
  }
  get list_hidden() {
    return this._rawData?.list_hidden ?? this._rawData?.config?.list_hidden ?? true
  }
  get options() {
    return this._rawData?.options || this._rawData?.config?.options || []
  }
  get main_display() {
    return this._rawData?.main_display ?? this._rawData?.config?.main_display ?? false
  }
  get visible_when_any() {
    return this._rawData?.visible_when_any || this._rawData?.config?.visible_when_any || []
  }
}
